import React from 'react'
import type { VideoPlayerBlock as VideoPlayerBlockProps } from '@/payload-types'
import ReactPlayer from 'react-player'

export function VideoPlayerBlock({ title, url }: Readonly<VideoPlayerBlockProps>): React.ReactNode {
  return (
    <section className="group p-8 bg-foreground">
      <div className="flex flex-col max-w-7xl mx-auto gap-8">
        {title ? (
          <header className="lg:flex-1 flex flex-col gap-4 self-center text-center">
            {title ? (
              <h2 className="text-lg lg:text-xl font-semibold text-background">{title}</h2>
            ) : null}
          </header>
        ) : null}
        <div>
          <ReactPlayer src={url} width="100%" height="auto" className="aspect-video" />
        </div>
      </div>
    </section>
  )
}
